import request from '../utils/request';

const url = 'scenic-spot/third-platform/';

export function GetGeoconvAsync(lng: number, lat: number): Promise<any> {
  return new Promise<any>(((resolve, reject) => {
    request({
      url: `${url}geoconv`,
      method: 'get',
      params: {
        lng,
        lat
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  }));
}

export function getAllWeather(city: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}weather`,
      method: 'get',
      params: {
        city
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}
